<template>
  <div>
    <div class="param-box">
      <div class="param-hd"><h3>{{rescenter_details.type == 1 ?'课后练习':'独立试卷'}}</h3></div>
      <div class="param-bd">
        <ul class="form-list">
          <li class="pure-text-row">
            <div class="form-label "><label for="">练习名称</label></div>
            <div class="form-input">
              <div class="form-unit"><p class="form-text">{{rescenter_details.name}}</p></div>
            </div>
          </li>
          <li class="pure-text-row">
            <div class="form-label "><label for="">习题数量</label></div>
            <div class="form-input">
              <div class="form-unit" v-if="rescenter_details.statistics_info">
                <p class="form-text">{{rescenter_details.statistics_info.judge_num+rescenter_details.statistics_info.multiple_num+rescenter_details.statistics_info.saq_num+rescenter_details.statistics_info.single_num}} 题</p>
              </div>
            </div>
          </li>
          <li class="pure-text-row">
            <div class="form-label "><label for="">所属专业</label></div>
            <div class="form-input">
              <div class="form-unit" v-if="rescenter_details.major_names"><p class="form-text">{{rescenter_details.major_names.join('，')}}</p></div>
            </div>
          </li>
          <li class="pure-text-row">
            <div class="form-label "><label for="">练习类型</label></div>
            <div class="form-input">
              <div class="form-unit">
                <p class="form-text" v-if="rescenter_details.statistics_info">
                  <span class="mr-5">单选 {{rescenter_details.statistics_info.single_num}} 题</span>
                  <span class="mr-5">多选 {{rescenter_details.statistics_info.multiple_num}} 题</span>
                  <span class="mr-5">判断题 {{rescenter_details.statistics_info.judge_num}} 题</span>
                  <span class="mr-5">简答题 {{rescenter_details.statistics_info.saq_num}} 题</span>
                </p>
              </div>
            </div>
          </li>
          <li class="pure-text-row">
            <div class="form-label "><label for="">练习限时</label></div>
            <div class="form-input">
              <div class="form-unit"><p class="form-text">{{rescenter_details.limited_time}} 分钟</p></div>
            </div>
          </li>
          <li class="pure-text-row">
            <div class="form-label "><label for="">练习总分</label></div>
            <div class="form-input">
              <div class="form-unit" v-if="rescenter_details.statistics_info">
                <p class="form-text">{{rescenter_details.statistics_info.total_score}} 分</p>
              </div>
            </div>
          </li>
          <li class="pure-text-row">
            <div class="form-label "><label for="">练习说明</label></div>
            <div class="form-input">
              <div class="form-unit"><p class="form-text">{{rescenter_details.introduction}}</p></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from "vuex";

  export default {
    name: "Details",
    computed: {
      ...mapState({
        rescenter_details: state => state.teachingScore.rescenter_details,
      }),
    },
  }
</script>

<style scoped lang="less">
  .param-box {
    .param-hd {
      line-height: 30px;
      color: #000;
      margin-bottom: 11px;
      height: 30px;
      h3 {
        display: inline-block;
        vertical-align: middle;
        font-size: 14px;
      }
    }
    .param-bd {
      padding-left: 0;
      .form-list {
        display: table;
        font-size: 12px;
        >li {
          display: table-row;
          .form-label {
            line-height: 25px;
            label {
              display: inline-block;
              color: #888;
              padding-right: 20px;
              white-space: nowrap;
              box-sizing: border-box;
            }
          }
          .form-label {
            display: table-cell;
            vertical-align: top;
            padding-bottom: 16px;
          }
          .form-text {
            font-size: 12px;
            color: #000;
          }
        }
      }
    }
  }
</style>
